const t=["ae","ar","arc","bcc","bqi","ckb","dv","fa","glk","he","ku","mzn","nqo","pnb","ps","sd","ug","ur","yi"],s=r=>!!r&&t.includes(r.split("-|_")[0].toLowerCase()),c=r=>s(r)?"rtl":"ltr";export{c as getLangDir,s as isRtl};
//# sourceMappingURL=rtlUtils.js.map
